var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextSnippet = function SvgTextSnippet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "text-snippet_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.667 4H42.3l13.033 13.034V60H8.667zm11.666 17.5H32v-4.667H20.333zm0 12.833v-4.666h23.334v4.666zm0 8.167v4.667h23.334V42.5z",
    clipRule: "evenodd"
  })));
};
export { SvgTextSnippet as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguNjY2NjYgNEg0Mi4yOTk4TDU1LjMzMzMgMTcuMDMzNVY2MEg4LjY2NjY2VjRaTTIwLjMzMzMgMjEuNUgzMlYxNi44MzMzSDIwLjMzMzNWMjEuNVpNMjAuMzMzMyAzNC4zMzMzVjI5LjY2NjdINDMuNjY2N1YzNC4zMzMzSDIwLjMzMzNaTTIwLjMzMzMgNDIuNVY0Ny4xNjY3SDQzLjY2NjdWNDIuNUgyMC4zMzMzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";